/**
 * Created by mozartdiniz on 12/2/14.
 */

Greenmile.Survey.SidebarFactory = {

    factoryItemFromJsonType: function (jsonType) {
        var item = new Greenmile.Survey.Sidebar[jsonType]();
        item.questionType = jsonType;

        return item;
    }
};
